import { Paragraph } from "../../components/styled/Text";

export const FailedTx = ({
  failedCount,
  txCount,
}: {
  failedCount: number;
  txCount: number;
}) => {
  return (
    <Paragraph textAlign="center">
      <strong>
        <span
          style={{
            color: "#FF0000",
          }}
        >
          {failedCount}
        </span>
      </strong>{" "}
      of{" "}
      <strong>
        <span
          style={{
            color: "#FF0000",
          }}
        >
          {txCount}
        </span>
      </strong>{" "}
      transactions failed.
    </Paragraph>
  );
};

export const ProcessedTx = ({
  processedCount,
  txCount,
}: {
  processedCount: number;
  txCount: number;
}) => {
  return (
    <Paragraph textAlign="center">
      <strong>
        <span
          style={{
            color: "green",
          }}
        >
          {processedCount}
        </span>
      </strong>{" "}
      of{" "}
      <strong>
        <span
          style={{
            color: "green",
          }}
        >
          {txCount}
        </span>
      </strong>{" "}
      transactions have been processed.
    </Paragraph>
  );
};
